import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Projects from '@/components/Projects'
import Create from '@/components/Create'
import ProjectDetail from '@/components/ProjectDetail'
import authService from '../auth'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
      beforeEnter: loginRequired
    },
    {
      path: '/projects/:id',
      name: 'ProjectDetail',
      component: ProjectDetail,
      beforeEnter: loginRequired,
      props: true
    },
    {
      path: '/create',
      name: 'CreateProject',
      component: Create,
      beforeEnter: loginRequired
    }
  ]
})

function loginRequired (to, from, next) {
  if (authService.authenticated()) {
    next()
  } else {
    authService.isLoaded().then(user => {
      if (authService.authenticated()) {
        next()
      } else {
        next('login')
      }
    })
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js